import React from 'react';
export function Footer() {
  return <footer className="bg-[#0A1F33] text-white/70 py-16 px-4 sm:px-6 lg:px-8 border-t border-white/10" data-id="element-58">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8" data-id="element-59">
        {/* Column 1 */}
        <div className="lg:pr-8" data-id="element-60">
          <h3 className="text-2xl font-heading font-bold text-white mb-4 tracking-tight" data-id="element-61">
            SyNeural
          </h3>
          <p className="text-sm leading-relaxed" data-id="element-62">
            Building better judgment for a more capable society.
          </p>
        </div>

        {/* Column 2 */}
        <div data-id="element-63">
          <h4 className="text-white font-heading font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-64">
            Platform
          </h4>
          <ul className="space-y-3 text-sm" data-id="element-65">
            <li data-id="element-66">
              <a href="#platform" className="hover:text-white transition-colors" data-id="element-67">
                Platform Overview
              </a>
            </li>
            <li data-id="element-68">
              <a href="#platform" className="hover:text-white transition-colors" data-id="element-69">
                CJI
              </a>
            </li>
            <li data-id="element-70">
              <a href="#platform" className="hover:text-white transition-colors" data-id="element-71">
                NCJI
              </a>
            </li>
            <li data-id="element-72">
              <a href="#platform" className="hover:text-white transition-colors" data-id="element-73">
                NCJI Atlas
              </a>
            </li>
          </ul>
        </div>

        {/* Column 3 */}
        <div data-id="element-74">
          <h4 className="text-white font-heading font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-75">
            Applications
          </h4>
          <ul className="space-y-3 text-sm" data-id="element-76">
            <li data-id="element-77">
              <a href="#applications" className="hover:text-white transition-colors" data-id="element-78">
                Education
              </a>
            </li>
            <li data-id="element-79">
              <a href="#applications" className="hover:text-white transition-colors" data-id="element-80">
                Employers
              </a>
            </li>
            <li data-id="element-81">
              <a href="#applications" className="hover:text-white transition-colors" data-id="element-82">
                Civil Society
              </a>
            </li>
            <li data-id="element-83">
              <a href="#applications" className="hover:text-white transition-colors" data-id="element-84">
                Government
              </a>
            </li>
            <li data-id="element-85">
              <a href="#applications" className="hover:text-white transition-colors" data-id="element-86">
                Leadership Development
              </a>
            </li>
          </ul>
        </div>

        {/* Column 4 */}
        <div data-id="element-87">
          <h4 className="text-white font-heading font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-88">
            Company
          </h4>
          <ul className="space-y-3 text-sm" data-id="element-89">
            <li data-id="element-90">
              <a href="#company" className="hover:text-white transition-colors" data-id="element-91">
                About
              </a>
            </li>
            <li data-id="element-92">
              <a href="#company" className="hover:text-white transition-colors" data-id="element-93">
                Research
              </a>
            </li>
            <li data-id="element-94">
              <a href="#company" className="hover:text-white transition-colors" data-id="element-95">
                Partnerships
              </a>
            </li>
            <li data-id="element-96">
              <a href="#contact" className="hover:text-white transition-colors" data-id="element-97">
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-white/10 text-xs flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-98">
        <p data-id="element-99">&copy; {new Date().getFullYear()} SyNeural. All rights reserved.</p>
        <div className="flex gap-6" data-id="element-100">
          <a href="#" className="hover:text-white transition-colors" data-id="element-101">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-102">
            Terms of Service
          </a>
        </div>
      </div>
    </footer>;
}